// extracted by mini-css-extract-plugin
export var caretAnchor = "_ws-0";
export var dropdownContent = "_ws-1";